import { useState } from "react";
import { Radio, RadioGroup } from "rsuite";

import AccountEditModal from "./AccountEditModal";
import API from "../../utils/api";
import { useModal } from "../../context/modal-context";
import { useConfig } from "../../context/config-context";

/**
 * UpdateOtpChannelModal - Modale pour choisir la méthode de confirmation d'identité
 * (canal d'envoi du code OTP du portail prescripteur : SMS ou mail)
 *
 * Fonctionnalités:
 * - SMS recommandé, indisponible si aucun numéro mobile n'est renseigné
 * - Appel API PUT /api/prescriber/profile
 */
export default function UpdateOtpChannelModal({
  currentChannel,
  hasMobilePhone,
  onSuccess,
}) {
  const { hideModal } = useModal();
  const siteConfig = useConfig();
  const [loading, setLoading] = useState(false);
  const [channel, setChannel] = useState(currentChannel);
  const [error, setError] = useState(null);

  /**
   * Soumet la méthode choisie
   */
  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      setLoading(true);
      setError(null);

      const response = await API.put(
        "/prescriber/profile",
        { otpChannel: channel },
        { silent: true }
      );

      if (response.data.success) {
        hideModal();
        onSuccess?.(response.data.data);
      }
    } catch (error) {
      setError(
        error.response?.data?.error?.message ||
          "Erreur lors de la mise à jour de la méthode de confirmation d'identité."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <AccountEditModal
      icon={siteConfig.medias.settings_svg}
      title="Méthode de confirmation d’identité"
      onSubmit={onSubmit}
      submitDisabled={channel === currentChannel}
      loading={loading}
    >
      <p className="text-sm leading-[22px] text-neutral-dark">
        Vous avez la possibilité de choisir la{" "}
        <strong className="font-bold">méthode d’authentification</strong> qui
        sera utilisée pour sécuriser votre connexion et accéder à la
        plateforme.
      </p>

      <div>
        <RadioGroup
          name="otpChannel"
          value={channel}
          onChange={setChannel}
          className="text-sm text-neutral-dark"
        >
          <Radio value="sms" disabled={!hasMobilePhone}>
            Envoi du code par SMS <em>(recommandé)</em>
          </Radio>
          <Radio value="email">Envoi du code par mail</Radio>
        </RadioGroup>

        {!hasMobilePhone && (
          <p className="text-xs italic text-neutral-medium">
            Renseignez un numéro de téléphone mobile pour recevoir le code par
            SMS.
          </p>
        )}
        {error && <div className="text-xs text-red-500">{error}</div>}
      </div>
    </AccountEditModal>
  );
}
